module.exports = __webpack_public_path__ + "assets/img/ga-icon.6cdc13ca.png";